module.exports = __webpack_public_path__ + "img/left_arrow.9263b4d7.svg";